<div class="row top-bar">
  <div class="col data top-bar-col">
    <div class="row center">
      <h4>Structure Number:</h4>
      <h3 class="padding sm left">
        {{ structure?.structureNumber || 'N/A' }}
      </h3>
    </div>
  </div>
  <div class="col data top-bar-col">
    <div class="row center">
      <h4>TMK:</h4>
      <h3 class="caption padding sm left">
        {{ keySystemDataSets?.keySystem?.topMasterKey || 'N/A' }}
      </h3>
    </div>
  </div>
  <div class="col data top-bar-col">
    <div class="row center">
      <h4>Combinating Rule:</h4>
      <h3 class="padding sm left">
        {{ combinatingRule?.name || 'N/A' }}
      </h3>
    </div>
  </div>
  <div class="col data top-bar-col">
    <div class="row center">
      <h4>Keyway Family:</h4>
      <h3 class="padding sm left">
        {{ keywayFamily?.name || 'N/A' }}
      </h3>
    </div>
  </div>
  <div class="col data top-bar-col last">
    <div class="row center">
      <h4>Status:</h4>
      <h3 class="padding sm left">
        {{ keySystemStatus || 'N/A' }}
      </h3>
    </div>
  </div>
</div>
